//
//
//
//
//
//
//
//
//
//

import VMask from '@/components/common/VMask';
export default {
  name: 'widget__popup',
  props: {
    confirm: Function,
    text: {
      type: String,
      default: '确定'
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    maskClicked: function maskClicked() {
      var type = this.type;
      this.$emit('maskClicked', type);
    }
  },
  components: {
    'v-mask': VMask
  }
};